import React from 'react'
import "./Rewards_cards.css"

function Rewards_cards() {
    return (
        <>
            <section className='Rewards_cards section_margin'>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="Rewards_card_holder">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text_holder">
                                        <h4>Grab Your </h4>
                                        <h1>Rewards Now!</h1>
                                        <p>Play games, complete tasks, and unlock amazing offers instantly.</p>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="img_holder">
                                        <img src="/assets/images/profile/rewards/rewards_cards/card_img.png" alt="" className='reword_card_img' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="Rewards_card_holder">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text_holder">
                                        <h4>Grab Your </h4>
                                        <h1>Rewards Now!</h1>
                                        <p>Play games, complete tasks, and unlock amazing offers instantly.</p>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="img_holder">
                                        <img src="/assets/images/profile/rewards/rewards_cards/card_img.png" alt="" className='reword_card_img' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Rewards_cards